import React from 'react'
import clsx from 'clsx'
import { Listbox } from '@headlessui/react'
import Icon from '../Icon/Icon'
import { differenceInDays, format, formatDistance } from 'date-fns'

import './selectInput.scss'
import { Fragment } from 'react'
import { formatCmpctNumber } from '../../utils/helpers'

export const SelectInput = ({
  otherClasses,
  selectedOption,
  setSelectedoption,
  defaultValue,
  allOptions,
  name,
  warning,
  isPriceDropDown,
  onChange,
}) => {
  const selectInputClasses = clsx(
    otherClasses,
    'overflow-hidden relative whitespace-nowrap flex justify-between text-left w-full  border-[1px] px-4 py-[13px] rounded-full  ',

    warning
      ? 'placeholder:text-[#ff4444] hover:bg-primary_blue_50 text-[20px] leading-[30px] placeholder:font-work-sans border-[#ff4444]  placeholder:text-[14px] placeholder:leading-[20px] placeholder:font-normal font-normal font-work-sans text-[#ff4444] focus:outline-[2px] active:border-[1px] active:outline-0 font-normal active:border-[#ff4444] focus:border-transparent focus:outline focus:outline-primary_dark_blue_500'
      : 'placeholder:text-primary_heading_color  hover:border-primary_dark_blue_500 hover: text-[20px] leading-[30px] placeholder:font-work-sans border-gray-500  placeholder:text-[14px] placeholder:leading-[20px] placeholder:font-normal font-normal font-work-sans text-primary_heading_color focus:outline-[2px] active:border-[1px] active:outline-0 font-normal active:border-gray-500 focus:border-transparent focus:outline focus:outline-primary_dark_blue_500'
  )

  return (
    <div data-testid="select-input" className="relative">
      <Listbox
        name={name}
        value={selectedOption}
        onChange={
          setSelectedoption ? setSelectedoption : (e) => onChange(e, name)
        }
      >
        {({ open }) => (
          <>
            <Listbox.Button
              className={clsx(selectInputClasses)}
              data-testid="select-input"
            >
              {isPriceDropDown ? (
                <p
                  className={clsx(
                    selectedOption?.length > 15
                      ? 'truncate_text'
                      : 'button_text',
                    defaultValue === selectedOption && 'opacity-60'
                  )}
                >
                  {selectedOption}
                </p>
              ) : (
                <p
                  className={clsx(
                    selectedOption?.length > 15
                      ? 'truncate_text'
                      : 'button_text',
                    defaultValue === selectedOption && 'opacity-60'
                  )}
                >
                  {selectedOption}
                </p>
              )}

              <span
                className={clsx(
                  'transition duration-200 absolute right-2 translate-y-[-50%] top-2/4',
                  open && ' rotate-180'
                )}
              >
                <Icon icon="down-caret" iconHeight={24} iconWidth={24} />
              </span>
            </Listbox.Button>

            {isPriceDropDown ? (
              <Listbox.Options className="scroll_select_dropdown max-h-[350px] overflow-auto absolute z-[5] left-0 w-full bg-white drop_down_main_container rounded-[10px]">
                {allOptions.map((person, index) => (
                  <Fragment key={index}>
                    <Listbox.Option
                      className="px-4 py-2 cursor-pointer text-sm leading-[18px] font-work-sans font-normal text-primary_heading_color hover:text-primary_dark_blue_500"
                      key={index}
                      value={person ? person : 'TBA'}
                    >
                      {person ? formatCmpctNumber(person) : 'TBA'}
                    </Listbox.Option>
                  </Fragment>
                ))}
              </Listbox.Options>
            ) : (
              <Listbox.Options className="scroll_select_dropdown max-h-[350px] overflow-auto absolute z-[5] left-0 w-full bg-white drop_down_main_container rounded-[10px]">
                {allOptions.map((person, index) => (
                  <Fragment key={index}>
                    {person && (
                      <Listbox.Option
                        className="px-4 py-2 cursor-pointer text-sm leading-[18px] font-work-sans font-normal text-primary_heading_color hover:text-primary_dark_blue_500"
                        key={index}
                        value={person && person}
                      >
                        {person}
                      </Listbox.Option>
                    )}
                  </Fragment>
                ))}
              </Listbox.Options>
            )}
          </>
        )}
      </Listbox>
    </div>
  )
}

export default SelectInput
